import { useEffect, useState } from 'react'
import { countAlertasAtivos } from '@services/crud.js'

/** Contador centralizado de alertas ativos com polling a cada 30s. */
export function useAlertasCount() {
  const [count, setCount] = useState(0)

  useEffect(() => {
    const refresh = () => countAlertasAtivos().then(setCount)
    refresh()
    const id = setInterval(refresh, 30_000)
    return () => clearInterval(id)
  }, [])

  return count
}
